import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolErrorIndicator } from '../ChatMessage/indicators/ChatToolErrorIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { I18nNamespace } from '~/common/types';

import { ToolResultComponent } from '.';

export const ExtractQuoteDetails: ToolResultComponent<
  Tool.extractQuoteDetails,
  { content: string },
  { success: true } | { success: false; error: string }
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });
  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t(`call`)} />;

    case 'output-available': {
      if (!tool.output.success) {
        return <ChatToolErrorIndicator message={t('error')} />;
      }
      return <ChatToolResultIndicator message={t(`result`)} />;
    }
  }
};
